var App = App || {};

App.Products = (function ($) {
    "use strict";

    var CONFIG = {
        TRIGGERS_SELECTOR: ".widget-products__productGroups button",
        PRODUCTS_CONTAINER_SELECTOR: ".widget-products__products",
        PRODUCTS_SELECTOR: ".widget-products__product",
        NO_RESULTS_SELECTOR: ".widget-products__noResults",
        RESET_SELECTOR: "[data-products='reset']"
    };

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var widget = this,
                    $triggers = $(widget).find(CONFIG.TRIGGERS_SELECTOR);

                $triggers.on("click", function () {
                    var isSelected = $(this).attr("aria-pressed") === "true";

                    $(this).attr("aria-pressed", isSelected ? "false" : "true");

                    ApplyFilter(widget, $triggers);
                });

                $(widget).find(CONFIG.RESET_SELECTOR).on("click", function () {
                    $triggers.attr("aria-pressed", "false");

                    ApplyFilter(widget, $triggers);
                });
            });
        }
    }

    function ApplyFilter(widget, $triggers) {
        var $productsContainer = $(widget).find(CONFIG.PRODUCTS_CONTAINER_SELECTOR),
            $products = $(widget).find(CONFIG.PRODUCTS_SELECTOR),
            $noResults = $(widget).find(CONFIG.NO_RESULTS_SELECTOR),
            $selected = $triggers.filter("[aria-pressed='true']");

        if (!$selected.length) {
            $products.show();
            $productsContainer.show();
            $noResults.hide();

            return;
        }

        // Intersection: a product must belong to every selected group
        var selectedIds = $selected
            .map(function () {
                return [String($(this).data("products")).split(",")];
            })
            .get()
            .reduce(function (acc, ids) {
                return acc.filter(function (id) {
                    return ids.includes(id);
                });
            });

        var matchCount = 0;

        $products.each(function () {
            var productId = String($(this).data("product")),
                isMatch = selectedIds.includes(productId);

            if (isMatch) {
                matchCount++;
            }

            $(this).toggle(isMatch);
        });

        $productsContainer.toggle(matchCount > 0);
        $noResults.toggle(matchCount === 0);
    }

    return {
        Init: Init
    };
})(jQuery);
